export default function PiPopupWindowStaticTitle(props: { title: string }) {
  const { title } = { ...props };

  return (
    <div className={"flex items-center w-full h-full"}>
      <div className={"font-bold text-[20px] text-interaction-primary"}>
        {title}
      </div>
    </div>
  );
}
